import { gql } from '@apollo/client';

export const GET_EXTERNAL_VEHICLES = gql`
  query getExternalVehicles(
    $appointmentAgentSettingsId: String!
    $search: String
    $first: Int
    $after: String
  ) {
    externalVehicles(
      appointmentAgentSettingsId: $appointmentAgentSettingsId
      search: $search
      first: $first
      after: $after
    ) {
      pageInfo {
        startCursor
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          make
          model
          year
          overrides {
            type
            numaServiceName
            opcodes {
              id
              serviceName
              dmsId
            }
          }
        }
      }
    }
  }
`;
